import { render, staticRenderFns } from "./ItemFilter.vue?vue&type=template&id=720925e8&scoped=true&"
import script from "./ItemFilter.vue?vue&type=script&lang=js&"
export * from "./ItemFilter.vue?vue&type=script&lang=js&"
import style0 from "./ItemFilter.vue?vue&type=style&index=0&id=720925e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720925e8",
  null
  
)

export default component.exports